export const visitPagelet = function* (ctx, visitorStep) {
  if (visitorStep.type !== 'pagelet') return;
  const pagelet = visitorStep.value;
  yield {
    type: 'layout',
    description: '',
    place: ['layout']
  };
  if (Array.isArray(pagelet.triggers)) {
    for (let i = 0; i < pagelet.triggers.length; i++) {
      yield {
        type: 'layout',
        description: `${i}号触发器`,
        place: ['triggers', i]
      };
    }
  }
};
//# sourceMappingURL=visitPagelet.js.map
